export const reduxKey = '@@devpage';
export const actionKey = '@@devpage';
export const defaultState = {
    viewOptions: {
        activeActionBar: 'primary'
    }
};

//# sourceMappingURL=constants.js.map